<template>
  <div>
    <ExamsTable />
  </div>
</template>

<script>
import ExamsTable from '@/components/ExamsTable.vue'

export default {
  components: {
    ExamsTable,
  },
  methods: {
    getDefaultData() {
      const data = { exams: [] }
      return data
    },
  },
}
</script>

<style></style>
